<!-- 鉴权页面 -->
<template>
  <div></div>
</template>

<script>
import { getOpenIdByCode, login } from '@/api/api';
export default {
  data() {
    return {};
  },

  components: {},

  computed: {},

  async mounted() {
    let obj = this.$route.query;
    // console.log(obj);
    // let openId = localStorage.getItem('openId')
    // if (openId && openId != 'null') {
    //     this.$router.replace(`/${obj.path}`)
    // }
    // else {
    if (obj.code) {
      let openId = await getOpenIdByCode({ code: obj.code, type: 0 }).then(
        (res) => res.data.openId,
      );
      let res = await login({ openId: openId, type: 4 });
      localStorage.setItem('token', res.data.token);
      localStorage.setItem('userId', res.data.userId);
      localStorage.setItem('openId', res.data.openId);
      this.$router.replace(`/${obj.state}`);
    } else {
      obj.path = obj.path.replace(/&/g, '%26'); // 附带参数 '&' 之后的参数无法在回调后识别，所以先转码
      let str = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${process.env.VUE_APP_ID}&redirect_uri=${process.env.VUE_APP_REDIRECT_URI}&response_type=code&scope=snsapi_base&state=${obj.path}#wechat_redirect`;
      window.location.href = str;
    }
    // }
  },

  methods: {},
};
</script>
<style></style>
